import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { hasPermission, PermissionCode } from '../helpers/permissions.helper';

/**
 * Functional guard to check if the current user has a specific permission
 * @param permission The permission code to check
 * @returns A CanActivateFn
 */
export const permissionGuard = (permission: PermissionCode): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const user = authService.getCurrentUser();
    
    if (user && hasPermission(user, permission)) {
      return true;
    }
    
    console.warn(`Access denied: missing permission ${permission}`);
    router.navigate(['/admin/dashboard']);
    return false;
  };
};
